'use strict';

var _classCallCheck = require("/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var Node = require('./node');

var Comment = /*#__PURE__*/function (_Node) {
  _inherits(Comment, _Node);

  var _super = _createSuper(Comment);

  function Comment(defaults) {
    var _this;

    _classCallCheck(this, Comment);

    _this = _super.call(this, defaults);
    _this.type = 'comment';
    return _this;
  }

  return Comment;
}(Node);

module.exports = Comment;
Comment["default"] = Comment;